//import { Injectable } from '@angular/core';
//import { Overlay, OverlayRef } from '@angular/cdk/overlay';
//import { ComponentPortal } from '@angular/cdk/portal';
//import { Subject } from 'rxjs';

import { OverlayRef } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class SharedLoadingService {
  private overlayRef: OverlayRef = null;
  private _loading: boolean;
  loadingStatus: Subject<boolean> = new Subject<boolean>();

  constructor() {
    this._loading = true;
  }

  get loading(): boolean {
    return this._loading;
  }

  set loading(value) {
    this._loading = value;
    this.loadingStatus.next(value);
  }

  public show() {
    this.loading = true;
  }

  public hide() {
    this.loading = false;
  }
}

